import { PlayerService } from '../../service/player.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NavController, NavParams, Select, App } from 'ionic-angular';
import { UserService } from '../../service/user.service';
import { AlbumPage } from '../album/album';
import { AlbumService } from '../../service/album.service';
import { album } from '../../models/album.model';

/**
 * Generated class for the PlayerPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-player',
  templateUrl: 'player.html',
})
export class PlayerPage implements OnInit {

  @ViewChild(Select) playlist: Select; 
  public selected_playlist:String;
  public selectOptions

  constructor(public navCtrl: NavController, public navParams: NavParams, public playerService: PlayerService,
    public us: UserService, public as: AlbumService, public appCtrl: App) {
  }

  ngOnInit() {

    this.selectOptions = {
      title: 'Lägg till i spellista',
    }

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PlayerPage');
  }

  seek(event) {
    console.log(event)
    this.playerService.seek(event.value);
    this.playerService.isPlayingUpdatable = true;
  }

  startseek() {
    this.playerService.isPlayingUpdatable = false;
  }

  
  addtolist()
  {
    this.playlist.open();
  }

  playlistChange(value:number)
  {
    this.us.setMediaToPlaylist(this.playerService.nowPlaying.id, value);
  }

  openAlbum()
  {
     
      this.as.allAlbums.forEach((item:album) => {
        
        if (item.id == this.playerService.nowPlaying.albumid)
        {
          this.appCtrl.getActiveNav().setRoot(AlbumPage,  {item: item});
          this.navCtrl.pop();
        }

      });


  }


}



// WEBPACK FOOTER //
// ./src/pages/player/player.ts